import List from './list';

let routes = [];
routes = routes.concat({ path: 'list', exact: true, name: 'basic', component: <List /> });

export default routes;
